import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import "@fontsource/open-sans"; // Defaults to weight 400
import "@fontsource/open-sans/400.css"; // Specify weight
import "@fontsource/open-sans/400-italic.css"; // Specify weight and style

import "@fontsource/caveat"; // Defaults to weight 400
import "@fontsource/caveat/400.css"; // Specify weight
import {
  Email,
  Password,
  People,
  Smartphone,
  Face6,
  CalendarMonth
} from "@mui/icons-material";
import { ToastContainer, toast } from "react-toastify";
import apilink from "../globals/Baseurls";
import axios from "axios";
import { Squares } from "react-activity";
import "react-activity/dist/library.css";

const SignUp = () => {
  const [family, setFamily] = useState("");
  const [alias, setAlias] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [date, setDate] = useState("");
  const [password, setPassword] = useState("");
  const [passwordcon, setPasswordcon] = useState("");
  const [val, setVal] = useState(false); //initializes checkbox to false
  const [posting, setPosting] = useState(false);

  const Checkbox = (props) => {
    return (
      <input
        type="checkbox"
        style={{
          color: "#ddd",
          alignItems: "center",
          justifyContent: "left",
          width: "20px",
          height: "20px",
          gap: "4px",
        }}
        checked={props.val}
        onChange={() => {
          props.setValue(!props.val);
        }}
      />
    );
  };
  const navigate = useNavigate();

  const handleSignUp = async () => {
    if (family === "") {
      toast.warn("Failed. Fill in the family name", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }
    if (alias === "") {
      toast.warn("Failed. Fill in your name", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }
    if (email === "") {
      toast.warn("Failed. Fill in your email", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }
    if (phone === "") {
      toast.warn("Failed. Fill in your phone number", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }
    if (password === "") {
      toast.warn("Failed. Fill in your password", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }
    if (password !== passwordcon) {
      toast.warn("Failed. Confirm password correctly", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }
    // if (posting === true) {
    //   return;
    // }

    setPosting(true);
    const baseUrl = apilink.link;

    await axios.get(`${baseUrl}/sanctum/csrf-cookie`, {
      withCredentials: true,
    });

    const dataObj = {
      family,
      alias,
      phone,
      email,
      password,
    };

    console.log(dataObj);


    axios
      .post(`${baseUrl}/family/signup`, dataObj, {
        withCredentials: true, // <-- important for Sanctum
      })
      .then((response) => {
        if (response.data.message === "Family registration successfull") {
          setPosting(false);
          setFamily("");
          setAlias("");
          setEmail("");
          setPhone("");
          setPassword("");
          setPasswordcon("");
          setVal(false);
          toast.success("Family registration successfull. Check email for further instructions", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          return;
        } else {
          setPosting(false);
          toast.warn(response.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          return;
        }
      })
      .catch((err) => {
        console.log(err);
        console.log("Error creating post");
      });

    //navigate("/admin");
  };

  const handleMemberSignIn = () => {
    navigate("/");
  };

  return (
    <>
      <div
        style={{
          flexDirection: "column",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "36px",
          paddingInline: 30,
        }}
      >
        <img
          alt="logo"
          style={{ width: "100px", height: "80px", resizeMode: "stretch" }}
          src={require("./logo.png")}
        />
        <h1
          className="navbar-brand mb-0"
          style={{ fontFamily: "Caveat", fontSize: 38 }}
        >
          <b>Collide - </b> Dating
        </h1>
        <p
          style={{
            color: "#010832",
            fontFamily: "Open Sans",
            marginTop: "30px",
          }}
        >
          New Account Registration
        </p>
         <p
          style={{
            color: "#00000090",
            fontFamily: "Open Sans",
            marginTop: "10px",
            fontSize: "12px"
          }}
        >
        <center>
         You are left with a few steps. Fill in your account <br /> details below and click the proceed button
        </center>
        </p>
        <div
          style={{
            width: "320px",
            borderWidth: 1,
            borderColor: "#010832",
            backgroundColor: "#010832",
            borderRadius: 5,
            height: 50,
            marginBottom: "10px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
          }}
        >
          <div
            style={{
              width: "40px",
              height: 50,
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <People style={{ color: "#ffffff" }} />
          </div>
          <div
            style={{
              height: 50,
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <input
              style={{
                height: 48.2,
                width: "279.2px",
                fontFamily: "Open Sans",
                fontSize: 14,
                paddingInline: 10,
                border: "1px solid white",
                borderTopRightRadius: 5,
                borderBottomRightRadius: 5,
                outlineStyle: "none",
              }}
              value={family}
              maxLength={20}
              placeholder="Display name"
              onChange={(e) => {
                setFamily(e.target.value);
              }}
            />
          </div>
          <div></div>
        </div>
        <div
          style={{
            width: "320px",
            borderWidth: 1,
            borderColor: "#010832",
            backgroundColor: "#010832",
            borderRadius: 5,
            height: 50,
            marginBottom: "10px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
          }}
        >
          <div
            style={{
              width: "40px",
              height: 50,
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Face6 style={{ color: "#ffffff" }} />
          </div>
          <div
            style={{
              height: 50,
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <select
              style={alias==""?{
                height: 48.7,
                width: "279.2px",
                fontFamily: "Open Sans",
                fontSize: 14,
                paddingInline: 5,
                border: "1px solid white",
                borderTopRightRadius: 5,
                borderBottomRightRadius: 5,
                outlineStyle: "none",
                color: "gray",
                backgroundColor: "#ffffff"
              }:{
                height: 48.7,
                width: "279.2px",
                fontFamily: "Open Sans",
                fontSize: 14,
                paddingInline: 5,
                border: "1px solid white",
                borderTopRightRadius: 5,
                borderBottomRightRadius: 5,
                outlineStyle: "none",
                color: "black",
                backgroundColor: "#ffffff"
              }}
              value={alias}
              maxLength={30}
              onChange={(e) => {
                setAlias(e.target.value);
              }}
            >
              <option value="" disabled selected>Gender</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Other">Other</option>
            </select>
            
          </div>
          <div></div>
        </div>
        <div
          style={{
            width: "320px",
            borderWidth: 1,
            borderColor: "#010832",
            backgroundColor: "#010832",
            borderRadius: 5,
            height: 50.6,
            marginBottom: "10px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
          }}
        >
          <div
            style={{
              width: "40px",
              height: 50,
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "right",
            }}
          >
            <CalendarMonth style={{ color: "#ffffff", marginTop: "10px" }} />
          </div>
          <div
            style={{
              height: 50,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <label style={{backgroundColor: "#ffffff", width: "279.2px", paddingLeft: "10px", color: "#00000085", fontFamily: "Open Sans",
                fontSize: 14, borderTop: "1px solid #010832", borderTopRightRadius: 5}}>Date of birth</label>
            <input
              style={{
                height: 50.7,
                width: "279.2px",
                fontFamily: "Open Sans",
                fontSize: 14,
                paddingInline: 6,
                border: "1px solid white",
                borderBottomRightRadius: 5,
                outlineStyle: "none",
                backgroundColor: "#ffffff"
              }}
              type="date"
              value={date}
              maxLength={30}
              onChange={(e) => {
                setDate(e.target.value);
              }}
            />
          </div>
          <div></div>
        </div>
    
        <div
          style={{
            width: "320px",
            borderWidth: 1,
            borderColor: "#010832",
            backgroundColor: "#010832",
            borderRadius: 5,
            height: 50,
            marginBottom: "10px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
          }}
        >
          <div
            style={{
              width: "40px",
              height: 50,
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Password style={{ color: "#ffffff" }} />
          </div>
          <div
            style={{
              height: 50,
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <input
              style={{
                height: 48.8,
                width: "279.2px",
                fontFamily: "Open Sans",
                fontSize: 14,
                paddingInline: 10,
                border: "1px solid white",
                borderTopRightRadius: 5,
                borderBottomRightRadius: 5,
                outlineStyle: "none",
              }}
              value={password}
              placeholder="Password"
              type="password"
              maxLength={20}
              onChange={(e) => {
                setPassword(e.target.value);
              }}
            />
          </div>
          <div></div>
        </div>
        <div
          style={{
            width: "320px",
            borderWidth: 1,
            borderColor: "#010832",
            backgroundColor: "#010832",
            borderRadius: 5,
            height: 50,
            marginBottom: "10px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
          }}
        >
          <div
            style={{
              width: "40px",
              height: 50,
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Password style={{ color: "#ffffff" }} />
          </div>
          <div
            style={{
              height: 50,
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <input
              style={{
                height: 48.8,
                width: "279.2px",
                fontFamily: "Open Sans",
                fontSize: 14,
                paddingInline: 10,
                border: "1px solid white",
                borderTopRightRadius: 5,
                borderBottomRightRadius: 5,
                outlineStyle: "none",
              }}
              value={passwordcon}
              placeholder="Confirm Password"
              type="password"
              maxLength={20}
              onChange={(e) => {
                setPasswordcon(e.target.value);
              }}
            />
          </div>
          <div></div>
        </div>
        <p
          style={{
            color: "#000000",
            fontFamily: "Open Sans",
            fontSize: 14,
            marginTop: "30px",
            alignSelf: "left",
            width: "320px",
          }}
        >
          <Checkbox value={val} setValue={setVal}></Checkbox>
          &nbsp;&nbsp;Agree to{" "}
          <span style={{ color: "#010832" }}>Terms and conditions</span>
        </p>
        <button
          onClick={() => handleSignUp()}
          style={{
            width: "320px",
            backgroundColor: "#010832",
            borderRadius: 5,
            border: "none",
            height: 50,
            fontFamily: "Open Sans",
            fontSize: 14,
            color: "white",
            marginTop: "10px",
          }}
        >
          {posting === false && <>Proceed</>}
          {posting && (
            <>
              <Squares />
            </>
          )}
        </button>

        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
        
      </div>
    </>
  );
};

export default SignUp;
